
import { message } from 'antd';
import { find } from 'lodash';
import { addAndUpdatePersosnnelAbility, getPersosnnelAbility, deletePersosnnelAbility } from '../services/supplierApi';

function init() {
  return {
    data: [],
    record: {},
    visiable: false
  };
}

export default {
  namespace: 'peopleAbility',
  state: init(),
  effects: {
    *getData(_, { call, put }) {
      const res = yield call(getPersosnnelAbility);
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              data: res.data
            }
          }
        });
      } else {
        res.msg && message.error(res.msg);
      }
    },
    *showEditModal({ payload: { data: { serialNumberP } } }, { put, select }) {
      const data = yield select(state => state.peopleAbility.data);
      const record = find(data, { serialNumberP });
      yield put({
        type: 'updateState',
        payload: {
          data: {
            record,
            visible: true
          }
        }
      });
    },
    *addAndUpdate({ payload: { data } }, { call, put }) {
      const result = yield call(addAndUpdatePersosnnelAbility, data);
      if (result.success) {
        message.success('操作成功');
        yield put({
          type: 'updateState',
          payload: {
            data: {
              visible: false
            }
          }
        });
        yield put({
          type: 'getData'
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *delete({ payload: { serialNumberP } }, { call, put }) {
      const result = yield call(deletePersosnnelAbility, { serialNumber: serialNumberP });
      if (result.success) {
        message.success('操作成功');
        yield put({
          type: 'getData'
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    },
    clear() {
      return init();
    }
  }
};

